import { ROUTES } from '@/constaint/route';
import {
  Briefcase,
  Buildings,
  GearSix,
  ShareNetwork,
  UserCircle,
  UsersThree,
  Sparkle,
  CurrencyDollar,
} from '@phosphor-icons/react';

export const NAVIGATION = [
  // {
  //   title: 'Dashboard',
  //   url: ROUTES.ADMIN.DASHBOARD,
  //   icon: <ChartPieSlice width={24} height={24} weight='bold' />,
  //   iconActive: <ChartPieSlice width={24} height={24} weight='fill' />,
  // },
  {
    title: 'Clients',
    url: ROUTES.ADMIN.CLIENT,
    icon: <Buildings width={24} height={24} weight='bold' />,
    iconActive: <Buildings width={24} height={24} weight='fill' />,
  },
  {
    title: 'Jobs',
    url: ROUTES.ADMIN.JOB,
    icon: <Briefcase width={24} height={24} weight='bold' />,
    iconActive: <Briefcase width={24} height={24} weight='fill' />,
  },
  {
    title: 'Application',
    url: ROUTES.ADMIN.APPLICATION,
    icon: <UsersThree width={24} height={24} weight='bold' />,
    iconActive: <UsersThree width={24} height={24} weight='fill' />,
  },
  {
    title: 'Recruiters',
    url: ROUTES.ADMIN.RECRUITER,
    icon: <ShareNetwork width={24} height={24} weight='bold' />,
    iconActive: <ShareNetwork width={24} height={24} weight='fill' />,
  },
  {
    title: 'Candidates',
    url: ROUTES.ADMIN.CANDIDATE,
    icon: <UserCircle width={24} height={24} weight='bold' />,
    iconActive: <UserCircle width={24} height={24} weight='fill' />,
  },
  {
    title: 'Payment',
    url: ROUTES.ADMIN.PAYMENT,
    icon: <CurrencyDollar width={24} height={24} weight='bold' />,
    iconActive: <CurrencyDollar width={24} height={24} weight='fill' />,
  },
  {
    title: 'AI Assistant',
    url: ROUTES.ADMIN.AI_ASSISTANT,
    icon: <Sparkle width={24} height={24} weight='bold' />,
    iconActive: <Sparkle width={24} height={24} weight='fill' />,
  },
  {
    title: 'Users Setting',
    url: ROUTES.ADMIN.USER_SETTING,
    icon: <GearSix width={24} height={24} weight='bold' />,
    iconActive: <GearSix width={24} height={24} weight='fill' />,
  },
];
